import { HeaderTabsComponent, LayoutWithWideSidebar, MenuHeader } from "@swivl-mono/ui";
import React, { useEffect } from "react";
import LocationsModel from "../../Models/Locations/Locations.Model";
import { LocationsListComponent } from "./Components/Locations.List.Component";

import { usePropertiesGetLocationIds } from "../../Hooks/usePropertiesGetLocationIds";
import LocationVarsModel from "../../Models/Variables/LocationVars.Model";
import { Outlet, useNavigate } from "react-router-dom";
import { APIScope, LocationScope } from "@swivl-mono/types";
import { ShowIf } from "../../Components/ShowIf/ShowIf";
import ModalModel from "../../Models/Modal/Modal.Model";
import { AddLocationOrGroupModal } from "./Modals/AddLocationsOrGroup.Modal";
import "../../Worksheets/Worksheets.scss";
import { Member } from "../../Models/Member/Member.Current";


export enum PropertiesViewPage {
  DETAILS = 'details',
  CORTEX = 'cortex',
  BRANDS = 'brands',
  CHATBOTS = 'chatbots',
  SPOT = 'spot'
}

export function PropertiesView() {
  const [searchQuery, setSearchQuery] = React.useState('');

  const page = usePropertiesGetLocationIds();
  const navigate = useNavigate();
  useEffect(() => {
    LocationsModel.getGroupsAndLocations(false);

  }, []);

  let headerTabeItems = [
    { to: `${page.preamble}/page/${PropertiesViewPage.DETAILS}`, label: 'Details' },
    { to: `${page.preamble}/page/${PropertiesViewPage.CORTEX}`, label: 'Cortex' },
    { to: `${page.preamble}/page/${PropertiesViewPage.SPOT}`, label: 'spot.is' },
  ]

  if (page.type === LocationScope.ORG) {
    if (Member.canSeeOrgSettings) {
      headerTabeItems = [
        { to: `${page.preamble}/page/${PropertiesViewPage.DETAILS}`, label: 'Details' },
        { to: `${page.preamble}/page/${PropertiesViewPage.CORTEX}`, label: 'Cortex' },
        { to: `${page.preamble}/page/${PropertiesViewPage.SPOT}`, label: 'spot.is' },
        { to: `${page.preamble}/page/${PropertiesViewPage.BRANDS}`, label: 'Brands' },
        { to: `${page.preamble}/page/${PropertiesViewPage.CHATBOTS}`, label: 'Chatbot' }

      ]
    } else {
      headerTabeItems = []
    }
  }


  return (
    <LayoutWithWideSidebar
      sidebar={<div className="flex flex-col " style={{ paddingTop: "58px", position: "relative" }}>

        <MenuHeader
          title="Property Manager"
          searchQuery={searchQuery}
          onSearch={setSearchQuery}
          overflowMenuItems={[
            <ShowIf scope={APIScope.LOCATION_CREATE} > <a
              onClick={() => {
                ModalModel.showModalWithContent(<h2>Add Location</h2>, <AddLocationOrGroupModal type="location" navigate={navigate} />)
              }}
            >Add Location</a></ShowIf>,
            <ShowIf scope={APIScope.LOCATION_CREATE} > <a
              onClick={() => {
                ModalModel.showModalWithContent(<h2>Add Group</h2>, <AddLocationOrGroupModal type="group" navigate={navigate} />)
              }}
            >Add Group</a></ShowIf>,
          ]}
        />

        <LocationsListComponent searchQuery={searchQuery}  {...page} />


      </div>
      }
      contentNoPadding={true}
      content={
        <div className="absolute left-0 top-0 bottom-0 right-0">
          <HeaderTabsComponent items={headerTabeItems} />
          <div className="LocationView__content absolute left-0 top-[58px] bottom-0 right-0">
            <Outlet />
          </div>
        </div>
      }
    />
  );

}